export default "__VITE_ASSET__DEhgRXzL__"